// extracted by mini-css-extract-plugin
module.exports = {"pkij":"style_pkij__3mEnf","l1":"style_l1__2OTX4","dv1":"style_dv1__gwuwT","img":"style_img__23CIR","fgsdte":"style_fgsdte__2BdPm","hfh":"style_hfh__3aV68"};